/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
//import { useStaticQuery, graphql } from "gatsby"
import Header from '../components/Header/index'
import SearchBar from "../components/Header/SearchBar/index"
import Footer from '../components/Footer/index'
import OurSites from '../components/Footer/OurSites/index'
import MainMenu from "../components/MainMenu"
import { MuiThemeProvider } from '@material-ui/core/styles';
import theme from './theme';
import "./pageStyles.scss";
import Helmet from 'react-helmet'

const Layout = ({ children }) => {
  // const data = useStaticQuery(graphql`
  //   query SiteTitleQuery {
  //     site {
  //       siteMetadata {
  //         title
  //       }
  //     }
  //   }
  //`)

  return (
    <>    
      <Helmet>
          <link rel="stylesheet" type="text/css" href="https://websurveys2.govmetric.com/css/client/gm_sidebar_cnr.css" />
          <script type="text/javascript" src="https://websurveys2.govmetric.com/js/client/gm_sidebar.js"></script>
          <script type="text/javascript" src="https://hitcounter.govmetric.com/1575"></script>
      </Helmet>
      <MuiThemeProvider theme={theme}>
      <Header/>
      <SearchBar/>
      <MainMenu />
      {/* <BreadCrumbs/> */}
      <main style={{marginTop:"15px"}}>{children}</main>
      <OurSites/>
      <Footer/>

      <div className="gm_sidebar gm_sidebar_cnr">
                        <a 
                                        href="https://websurveys2.govmetric.com/theme/gm/1574"
                                        target="_blank" 
                                        className="gm_sidebar_anchor feedback" 
                                        title="feedback" 
                                        rel="nofollow">
                                        <img src="https://websurveys2.govmetric.com/imgs/triggers/cnr.png" alt="rating button" />
                        </a>
        </div>      
      </MuiThemeProvider>  
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
